import { Controller } from "@hotwired/stimulus"

// The call button and its "výsledok hovoru" form (calls/_form). Following the
// tel: link opens the form, so the outcome can be logged the moment the call
// ends; the form works without this controller too (everything is visible).
//
// - dial: opens the form's <details>, picks the dialled number and notes the
//   time, so a connected call's duration can be prefilled in whole minutes.
// - outcome: shows the "kedy" field only for "zavolať neskôr" and suggests the
//   outreach status that goes with the outcome, unless the rep chose one.
// - shortcuts (call list): keys 1–7 pick an outcome, Enter in no field submits.
export default class extends Controller {
  static targets = ["panel", "callback", "callbackInput", "status", "duration", "point"]
  static values = { suggest: Object, shortcuts: Boolean }

  connect() {
    this.statusTouched = false
    this.sync()
    if (this.shortcutsValue) {
      this.keydown = this.onKeydown.bind(this)
      document.addEventListener("keydown", this.keydown)
    }
  }

  disconnect() {
    if (this.keydown) document.removeEventListener("keydown", this.keydown)
  }

  dial(event) {
    this.dialledAt = Date.now()
    if (this.hasPanelTarget) this.panelTarget.open = true
    const id = event.currentTarget.dataset.pointId
    const radio = this.pointTargets.find((input) => input.value === id)
    if (radio) radio.checked = true
  }

  outcome() {
    this.sync()
    const outcome = this.selectedOutcome()
    const suggestion = this.suggestValue[outcome]
    if (this.hasStatusTarget && !this.statusTouched) this.statusTarget.value = suggestion || ""
    const talked = ["connected", "interested", "not_interested", "call_back"].includes(outcome)
    if (talked && this.dialledAt && this.hasDurationTarget && this.durationTarget.value === "") {
      this.durationTarget.value = Math.max(1, Math.round((Date.now() - this.dialledAt) / 60000))
    }
  }

  statusChosen() {
    this.statusTouched = true
  }

  sync() {
    if (!this.hasCallbackTarget) return
    const later = this.selectedOutcome() === "call_back"
    this.callbackTarget.hidden = !later
    if (this.hasCallbackInputTarget) this.callbackInputTarget.required = later
  }

  selectedOutcome() {
    const checked = this.element.querySelector("input[name='call[outcome]']:checked")
    return checked ? checked.value : null
  }

  onKeydown(event) {
    if (event.metaKey || event.ctrlKey || event.altKey) return
    const field = event.target.closest("input, textarea, select, [contenteditable]")
    if (field && !(field.type === "radio")) return

    const radios = Array.from(this.element.querySelectorAll("input[name='call[outcome]']"))
    const index = Number.parseInt(event.key, 10)
    if (index >= 1 && index <= radios.length) {
      radios[index - 1].checked = true
      radios[index - 1].focus()
      this.outcome()
      event.preventDefault()
    } else if (event.key === "Enter" && this.selectedOutcome()) {
      this.element.querySelector("form")?.requestSubmit()
      event.preventDefault()
    }
  }
}
